import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TermsOfUsePage from './termOfUse';
import Privacy from './privacy';
import MobileApps from './apps';

interface Props { }

const Pages = (props: Props) => {


  return (

        <Routes>
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/apps" element={<MobileApps />} />
        </Routes>
  );
};

export default Pages;
